import { BASE_WARNING_VARIANT } from "../Configurations/WarningConfigurations.js";

// i18next key conventions for warning copy. `BASE` variant collapses to the
// type-level description key so renderers don't need to special-case it.

/**
 * Builds the i18next key for a warning title.
 * Use this when resolving warning titles from the shared warnings catalog.
 */
export function getWarningTitleKey(warningType: string): string {
    return `${warningType}.title`;
}

/**
 * Builds the i18next key for a warning description.
 * This normalizes BASE/no variant to the type-level description key so callers
 * can resolve description copy without variant special-casing.
 */
export function getWarningDescriptionKey(warningType: string, variant?: string): string {
    if (variant === undefined || variant === BASE_WARNING_VARIANT) {
        return `${warningType}.description`;
    }
    return `${warningType}.${variant}.description`;
}

/**
 * Builds the i18next key for a warning type's prospective "fires when" copy.
 * Use this wherever a surface describes what would trigger a type rather than reporting an
 * already-posted warning — subscription pickers today, and anywhere else the prospective
 * phrasing fits. Every warning type carries this string.
 */
export function getWarningFiresWhenKey(warningType: string): string {
    return `${warningType}.fires-when`;
}

/**
 * Builds the i18next key for a warning problem item.
 * Use this for nested problem text lookup under `<warningType>.problems.*`.
 */
export function getWarningProblemKey(warningType: string, problemKey: string): string {
    return `${warningType}.problems.${problemKey}`;
}

/**
 * Builds the i18next key for a warning fix item.
 * Use this for nested fix text lookup under `<warningType>.fixes.*`.
 */
export function getWarningFixKey(warningType: string, fixKey: string): string {
    return `${warningType}.fixes.${fixKey}`;
}
